import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import {Grid2, Stack, Tooltip} from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import Done from "@mui/icons-material/Done";
import Close from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import useSociety from "../../../../hooks/useSociety";
import useDataPut from "../../../../hooks/useDataPut";
import {SocietyDTO} from "../../../../context/SocietyProvider";
import CustomTextField from "../../../customMUIComponents/CustomTextField";
import {Visibility, VisibilityOff} from "@mui/icons-material";

const ContactDetails = () => {
    const {society} = useSociety();

    const [editSocietyAddress, setEditSocietyAddress] = useState<boolean>(false);
    const [newSocietyZip, setNewSocietyZip] = useState<string>(society.societyContactDetails?.zip!);
    const [newSocietyCity, setNewSocietyCity] = useState<string>(society.societyContactDetails?.city!);
    const [newSocietyStreet, setNewSocietyStreet] = useState<string>(society.societyContactDetails?.street!);
    const [newSocietyStreetNumber, setNewSocietyStreetNumber] = useState<string>(society.societyContactDetails?.streetNumber!);

    const [hideAddress, setHideAddress] = useState<boolean>(society.societyContactDetails?.hideAddress!);

    const {putData} = useDataPut<SocietyDTO>(`/societies/${society.id}/contact-details`, {}, true, false);


    const handleEditSocietyName = (hideAddress: boolean) => {
        setEditSocietyAddress(!editSocietyAddress);
        putData(undefined, {
            societyId: society.id,
            zip: newSocietyZip,
            city: newSocietyCity,
            street: newSocietyStreet,
            streetNumber: newSocietyStreetNumber,
            hideAddress: hideAddress

        }).then((data: any) => {
            window.location.reload();
        })
    }

    return (

        <Grid2 container size={12}>

            {!editSocietyAddress ? (
                <Grid2 size={12} textAlign={{xs: "center", md: "left"}}>
                    <Typography
                        sx={{
                            fontSize: {xs: 22, sm: 24, md: 26},
                        }}
                        variant={"fourthVariant"}
                    >
                        Adresse
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: {xs: 16, sm: 18, md: 20},
                        }}
                        variant={"fourthVariant"}
                    >
                        {society.societyContactDetails?.zip} {society.societyContactDetails?.city}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: {xs: 16, sm: 18, md: 20},
                        }}
                        variant={"fourthVariant"}
                    >
                        {society.societyContactDetails?.street} {society.societyContactDetails?.streetNumber}
                    </Typography>

                    {society.societyContactDetails?.hideAddress && (
                        <Typography
                            sx={{
                                fontSize: {xs: 16, sm: 18, md: 20},
                            }}
                            variant={"fourthVariant"}
                        >
                            Votre adresse est masquée aux visiteurs.
                        </Typography>

                    )}
                </Grid2>
            ) : (
                <Grid2 size={12} textAlign={"left"}>
                    <Stack spacing={2} direction="row" sx={{marginBottom: 4}}>
                        <CustomTextField
                            value={newSocietyZip}
                            label="Code postal"
                            setField={setNewSocietyZip}
                            required/>
                        <CustomTextField
                            value={newSocietyCity}
                            label="Localité"
                            setField={setNewSocietyCity}
                            required/>
                    </Stack>
                    <Stack spacing={2} direction="row" sx={{marginBottom: 4}}>
                        <CustomTextField
                            value={newSocietyStreet}
                            label="Rue"
                            setField={setNewSocietyStreet}
                            required/>
                        <CustomTextField
                            value={newSocietyStreetNumber}
                            label="N° de rue"
                            setField={setNewSocietyStreetNumber}
                            required/>
                    </Stack>
                </Grid2>
            )}

            <Grid2
                textAlign={{xs: "center", md: "left"}}
                container
                size={12}
                sx={{
                    alignContent: 'center',
                    display: society.secured ? 'block' : 'none',
                }}>
                {!editSocietyAddress ? (
                    <>
                        <IconButton
                            aria-label="Instagram"
                            variant="secondVariant"
                            onClick={() => {
                                setNewSocietyZip(society.societyContactDetails?.zip!)
                                setNewSocietyCity(society.societyContactDetails?.city!)
                                setNewSocietyStreet(society.societyContactDetails?.street!)
                                setNewSocietyStreetNumber(society.societyContactDetails?.streetNumber!)
                                setEditSocietyAddress(true)
                            }}
                        >
                            <Edit/>
                        </IconButton>
                        <Tooltip title={hideAddress ? "Afficher l'adresse" : "Cacher l'adresse"}>
                            <IconButton
                                aria-label="Instagram"
                                variant="secondVariant"
                                onClick={() => {
                                    const hideAddressUpdated = !hideAddress;
                                    setHideAddress(hideAddressUpdated);
                                    handleEditSocietyName(hideAddressUpdated);
                                }}
                            >
                                {hideAddress ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </Tooltip>
                    </>
                ) : (
                    <>
                        <IconButton
                            aria-label="Instagram"
                            variant="secondVariant"
                            onClick={() => handleEditSocietyName(hideAddress)}
                        >
                            <Done/>
                        </IconButton>
                        <IconButton
                            aria-label="Instagram"
                            variant="secondVariant"
                            onClick={() => setEditSocietyAddress(false)}
                        >
                            <Close/>
                        </IconButton>
                    </>
                )}
            </Grid2>
        </Grid2>
    );
}

export default ContactDetails
